export const getEventClassNames = ({ styles, event }) => {
    const t = (event.extendedProps?.tipo || "GEN").toUpperCase();
    const sub = (event.extendedProps?.subTipoCaceria || event.title || "").toLowerCase();
    const provisional = event.extendedProps?.esProvisional;

    const classes = [styles["evt"]];

    if (t === "EVENTO") classes.push(styles["evt-evento"]);
    if (t === "GEN") classes.push(styles["evt-generico"]);

    if (t === "CACERIA") {
        classes.push(styles["evt-caceria"]);

        if (sub.includes("ojeo")) classes.push(styles["caceria-ojeo"]);
        else if (sub.includes("monter")) classes.push(styles["caceria-monteria"]);
        else if (sub.includes("caza en mano")) classes.push(styles["caceria-mano"]);
        else if (sub.includes("gancho")) classes.push(styles["caceria-gancho"]);
        else if (sub.includes("rececho")) classes.push(styles["caceria-rececho"]);
        else if (sub.includes("aguardo")) classes.push(styles["caceria-aguardo"]);
        else if (sub.includes("otro")) classes.push(styles["caceria-otro"]);
        else classes.push(styles["caceria-mano"]);
    }

    if (provisional) classes.push(styles["evt-provisional"]);
    return classes;
};

export const getAgendaClass = ({ styles, ev }) => {
    const t = (ev.extendedProps?.tipo || "GEN").toUpperCase();
    const sub = (ev.extendedProps?.subTipoCaceria || ev.title || "").toLowerCase();

    if (t === "EVENTO") return styles["ag-evento"];
    if (t !== "CACERIA") return styles["ag-generico"];

    if (sub.includes("ojeo")) return styles["ag-ojeo"];
    if (sub.includes("monter")) return styles["ag-monteria"];
    if (sub.includes("caza en mano")) return styles["ag-mano"];
    if (sub.includes("gancho")) return styles["ag-gancho"];
    if (sub.includes("rececho")) return styles["ag-rececho"];
    if (sub.includes("aguardo")) return styles["ag-aguardo"];
    if (sub.includes("otro")) return styles["ag-otro"];
    return styles["ag-caceria"];
};
